import React, { useState } from "react";
import { useTranslation, Trans } from "react-i18next";

import {
  Modal,
  Alert
} from '@lockerpm/design';

import global from "../../../../config/global";
import relayServices from "../../../../services/relay";

const DeleteModal = (props) => {
  const {
    visible = false,
    item = {},
    onClose = () => { },
  } = props;
  const { t } = useTranslation();

  const [callingAPI, setCallingAPI] = useState(false);

  const deleteAlias = async () => {
    setCallingAPI(true);
    await relayServices.delete_address(item?.id).then(() => {
      global.pushSuccess(t('notification.success.alias.deleted'));
      onClose(true)
    }).catch((error) => {
      global.pushError(error)
    })
    setCallingAPI(false);
  }

  return (
    <Modal
      className="confirm-password"
      title={t('private_email.delete_alias.title')}
      open={visible}
      width={500}
      okText={t('private_email.delete_alias.button')}
      cancelText={t('button.cancel')}
      onOk={() => deleteAlias()}
      onCancel={() => onClose()}
      okButtonProps={{
        loading: callingAPI,
      }}
      cancelButtonProps={{
        disabled: callingAPI
      }}
    >
      <p className="text-primary my-4 font-semibold">
        {item?.full_address}
      </p>
      <div className="mb-4">
        <Trans
          i18nKey='private_email.delete_alias.description'
          values={{
            alias: item?.full_address,
          }}
        />
      </div>
      <Alert
        className="mb-8"
        description={t('private_email.delete_alias.warning')}
        type="error"
        closable={false}
      />
    </Modal>
  );
}

export default DeleteModal;